import { render } from "./card-activity.vue?vue&type=template&id=cebbd836&scoped=true&ts=true"
import script from "./card-activity.vue?vue&type=script&lang=ts"
export * from "./card-activity.vue?vue&type=script&lang=ts"

import "./card-activity.vue?vue&type=style&index=0&id=cebbd836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebbd836"]])

export default __exports__